

































































import { Component, Mixins, Prop, Ref } from "vue-property-decorator";
import UsersMixin from "@/mixins/http/UsersMixin";
import { User } from "@/models";
import DataTable from "@monade/vue-components/src/components/VDataTable.vue";
import Paginator from "@monade/vue-components/src/components/VPaginator.vue";
import EditUserModal from "@/components/User/Edit.vue";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";

interface ColumnData {
  name: string;
  label: string;
}

@Component({ components: { DataTable, Paginator, EditUserModal } })
export default class UsersList extends Mixins(UsersMixin) {
  private users: User[] = [];
  static usersListTag = "get_company_users_list";
  private page = 1;
  @Prop({ required: true }) companyId!: string;

  @Ref() readonly editModal!: EditUserModal;

  @RegisterHttp(UsersList.usersListTag)
  private usersListRequest: RequestData;

  private getActivation(user: User) {
    if (user.confirmedAt !== null) {
      return "Active";
    } else {
      return "Waiting";
    }
  }

  openEdit(item: User) {
    this.$router.push({
      name: "company_users_edit",
      params: { id: this.companyId, user_id: item.id },
    });
  }

  private getActivationClass(user: User) {
    return user.confirmedAt != null ? "" : "text-warning";
  }

  get hasItems(): boolean {
    return this.users.length > 0;
  }

  get columns() {
    const columns = [];
    this.pushColumnInAllScreens(columns, { name: "fullname", label: "Name" });
    this.pushColumnInAllScreens(columns, { name: "email", label: "E-mail" });
    this.pushColumnInAllScreens(columns, { name: "role", label: "Role" });
    this.pushColumnInAllScreens(columns, {
      name: "state",
      label: "Activation",
    });
    this.pushColumnInLargeScreens(columns, {
      name: "currentSignInAt",
      label: "Last access",
    });
    this.pushColumnInAllScreens(columns, { name: "controls", label: "" });

    return columns;
  }

  private pushColumnInAllScreens(columns, column: ColumnData) {
    columns.push(column);
  }
  private pushColumnInLargeScreens(columns, column: ColumnData) {
    if (this.isScreenLarge()) {
      columns.push(column);
    }
  }

  private isScreenLarge() {
    return (
      this.$mq !== "xs" &&
      this.$mq !== "sm" &&
      this.$mq !== "md" &&
      this.$mq !== "lg"
    );
  }

  async created() {
    await this.loadUsers();
  }

  async loadUsers() {
    this.users =
      (await this.getUsers(this.payload, UsersList.usersListTag)) || [];
  }

  get payload() {
    return {
      page: this.page,
      filter: {
        company: this.companyId,
      },
    };
  }

  async onPageChange(page) {
    this.page = page;
    await this.loadUsers();
  }

  get meta() {
    return this.usersListRequest?.meta;
  }
}
